import DOMPurify from 'dompurify';
import { fetchClientConfig } from '../pages/agentSms/utils';
import { AppointmentType, Lead } from '../types';

export const crmLink = (
  lead: Pick<Lead, 'client_id' | 'source_id'>,
): string => {
  if (lead.client_id === 1) {
    return `https://client14.sierrainteractivedev.com/lead-detail.aspx?id=${lead.source_id}`;
  } else if (lead.client_id === 2) {
    return `https://carolinaone2.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 3) {
    return `https://pacaso.lightning.force.com/lightning/r/Lead/${lead.source_id}/view/`;
  } else if (lead.client_id === 4) {
    return `https://laughtonteam1.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 5) {
    return `https://app.hubspot.com/contacts/46350142/record/0-1/${lead.source_id}`;
  } else if (lead.client_id === 6) {
    return `https://robertjslack.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 7) {
    return `https://chordrealestate.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 8) {
    return `https://onepathteam.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 9) {
    return `https://rockwell.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 10) {
    return `https://novakteam.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 11) {
    return `https://buyvet1.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 12) {
    return `https://client14.sierrainteractivedev.com/lead-detail.aspx?id=${lead.source_id}`;
  } else if (lead.client_id === 13) {
    return `https://theagencyre16.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 14) {
    return `https://robertslackga.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 15) {
    return `https://robertslack5.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 16) {
    return `https://realatlas.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 17) {
    return `https://frontgate.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 18) {
    return `https://k2realtyteam.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 19) {
    return `https://soldbycarin.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 20) {
    return `https://sandersteam.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 21) {
    return `https://itzsold.followupboss.com/2/people/view/${lead.source_id}`;
  } else if (lead.client_id === 22) {
    return `https://djandlindsey.followupboss.com/2/people/view/${lead.source_id}`;
  }
  return '';
};

export const fetchAppointmentTypes = async (
  apiUrl: string,
  clientId: string,
  accessToken?: string,
): Promise<AppointmentType[]> => {
  try {
    const config = await fetchClientConfig(clientId, accessToken, apiUrl);
    if (!config) {
      throw new Error('Failed to fetch client config');
    }
    return config.appointment_types || [];
  } catch (error) {
    console.error('Error fetching appointment types:', error);
    throw error;
  }
};

export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (!phone) {
    return '';
  }
  const digits = phone.replace(/\D/g, '');
  const ten =
    digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length === 10) {
    return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
  }
  return phone;
};

// Phone validation helpers
export const normalizePhone = (value: string): string =>
  value.replace(/[\s\-\(\)]/g, '');

export const validatePhoneOverride = (
  value: string | undefined | null,
  dialerPhone?: string | null,
): string | undefined => {
  const v = (value || '').trim();
  if (!v) {
    return undefined;
  }
  const normalized = normalizePhone(v);
  if (!/^\+1\d{10}$/.test(normalized)) {
    return 'Phone must be in +1XXXXXXXXXX format';
  }
  const dialer = normalizePhone(dialerPhone || '');
  if (dialer && normalized === dialer) {
    return 'Phone override cannot be the dialer number';
  }
  return undefined;
};

/**
 * Safely sanitizes HTML content to prevent XSS
 */
export const sanitizeHTML = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ADD_ATTR: ['style'],
  });
};

/**
 * Escapes HTML special characters to prevent injection when interpolating into HTML strings
 */
export const escapeHTML = (text: string): string => {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};
